<ng-container *ngIf="_visible">
  <ng-container *ngIf="_purchaseable === 'loading'">
    <button class="w-100 btn btn-dark" disabled>Loading...</button>
  </ng-container>
  <ng-container *ngIf="_purchaseable !== 'loading'">
    <!-- <a
      class="mb-1 d-flex"
      [routerLink]="['/collections/insulated-infuser-flasks']"
    >
      <img
        class="w-100 h-auto"
        src="/assets/Earth_Day_Sale_Assets_April_2025_Sales_Callout_840x200px.jpg"
      />
    </a> -->
    <button class="w-100 btn btn-warning" *ngIf="_preorderMessaging">
      {{ _preorderMessaging }}
    </button>

    <ng-container *ngIf="_purchaseable === 'outofstock'">
      <button (click)="popDrawer()" class="w-100 btn btn-lg btn-dark">
        Notify me when back in stock
      </button>
    </ng-container>
    <ng-container *ngIf="_purchaseable === 'add'">
      <button (click)="addToCart()" class="w-100 btn btn-dark">
        {{ _text }}
      </button>

      <a
        *ngIf="
          ['AU', 'INT'].includes(environment.store) &&
          product?.tags?.includes('personalise')
        "
        [routerLink]="['/personaliser-product/' + product.handle]"
        [queryParams]="{
          variantId: _selectedVariant.id
        }"
        class="w-100 mt-2 btn btn-outline-dark"
        >Personalise</a
      >
    </ng-container>
  </ng-container>
</ng-container>
